<template>
  <v-ons-page>
    <div class="sticky1">
      <v-ons-list>
        <v-ons-list-item style="font-size: 0.8em">
          <div class="center">
            <v-ons-button @click="dialogReminderConfig = true" :disabled="messages.length === 0">
              次回リマインド日：
              <span v-if="lic.isValid === false">無効</span>
              <span v-else-if="lic.remindDate > 0">
                {{lic.remindDate | unixTime2ymdDay}}
              </span>
              <span v-else>未設定</span>
            </v-ons-button>

            <!-- <a href="https://firebasestorage.googleapis.com/v0/b/miley-lasmeru.appspot.com/o/attachment%2FIFJrWkWhwNXQlwUz1vmEVLaGfgK2%2Fmessages%2F39ZhBtmAmkDKdEm3GwqR%2Fmovie%2F%E3%82%A4%E3%83%A1%E3%83%BC%E3%82%B7%E3%82%99PV%EF%BC%91.mp4?alt=media&token=977dbe9d-9e75-47e5-becf-32545e1d5871" download="test.mov" target="_blank">ダウンロード</a> -->
            <!-- <a href="https://firebasestorage.googleapis.com/v0/b/miley-lasmeru.appspot.com/o/attachment%2FIFJrWkWhwNXQlwUz1vmEVLaGfgK2%2Fmessages%2F39ZhBtmAmkDKdEm3GwqR%2FQR_Miley_android.png?alt=media&token=9367743e-d45f-463f-a120-e1dd402879ff" download="test.png">ダウンロード</a> -->
          </div>
          <div class="right">
            <v-ons-button @click="checkToProceed()" modifier="quiet"><v-ons-icon icon="fa-plus"></v-ons-icon></v-ons-button>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </div>

    <div class="bodycontent">
      <div v-show="loading">
        <p style="text-align: center; z-index: 9999;">
          <v-ons-progress-bar indeterminate></v-ons-progress-bar>
        </p>
      </div>

      <v-ons-list v-show="readyToShow">
        <div v-for="(item, index) in messages" :key="index" @click="showItem(item)">
          <v-ons-list-item tappable>
            <div class="left">
              <span v-show="item.type === 'email'"><v-ons-icon style="color: #4EBFE9" size="20px" icon="fa-envelope"></v-ons-icon></span>
              <span v-show="item.type === 'twitter'"><v-ons-icon style="color: #4EBFE9" size="20px" icon="fa-twitter"></v-ons-icon></span>
              <!-- <span v-else><v-ons-icon style="color: red;" size="10px" icon="fa-circle"></v-ons-icon></span> -->
            </div>
            <div class="center">
              <span v-show="item.type === 'email'" class="list-item__title" style="font-size: 0.9em;">{{ item.title }}</span>
              <span v-show="item.type === 'twitter'" class="list-item__title" style="font-size: 0.9em;">{{ item.content }}</span>
              <span class="list-item__subtitle" style="font-size: 0.7em;">ステータス：
                <span v-show="item.isValid" style="color: lightgreen;">お預かり中</span>
                <span v-show="item.isValid === false" style="color: darkgrey;">送信済み</span>
              </span>
            </div>
            <div class="right">
              <span class="list-item__subtitle" style="font-size: 0.6em">
                {{ item.timeStamp | unixTime2ymdDay }}
              </span>
            </div>
          </v-ons-list-item>
        </div>
      </v-ons-list>
      <v-ons-list-item modifier="nodivider" v-show="messages.length === 0">
        <div class="center">新着投稿はありません。</div>
      </v-ons-list-item>

    </div>

    <v-ons-dialog :visible.sync="dialogReminderConfig">
      <div class="dialogview2">
        <v-ons-button class="closebutton" modifier="quiet" @click="dialogReminderConfig = false"><v-ons-icon icon="fa-window-close"></v-ons-icon></v-ons-button>
        <v-ons-card>
          <div class="content">
            <v-ons-list>
              <v-ons-list-header>リマインド日について</v-ons-list-header>
              <!-- <v-ons-list-item>
                <div class="center">
                  <v-ons-select v-model="reminder.remindSelect">
                    <option v-for="(rd, index) in remindDates" :value="index" :key="'remind-' + index">
                      {{ rd.text }}
                    </option>
                  </v-ons-select>
                </div>
              </v-ons-list-item> -->
              <v-ons-list-item>
                <div class="center">
                  <span style="color: gray; font-size: 0.8em;">
                    設定した日数経過時にあなたへリマインドメールを送信します。<br>
                    リマインドメール受信後にログインすることでリマインド日が更新されます。<br>
                    リマインド日から{{triggerDays}}日間以内にログインされない場合には、登録した宛先にメッセージが送信されます。<br>
                    リマインド日の設定はアカウント単位ですので全てのトリガー型メッセージに適用されます。
                  </span>
                </div>
              </v-ons-list-item>
              <!-- <v-ons-list-item>
                <div class="center">
                  <v-ons-button modifier="large" @click="updateReminder(reminder)">保存</v-ons-button>
                </div>
              </v-ons-list-item> -->
            </v-ons-list>
          </div>
        </v-ons-card>
      </div>
    </v-ons-dialog>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import common from '../util/common'
import comReminder from '../util/com_reminder'
import comLic from '../util/com_license'

export default {
  name: 'MsgRoot',
  mixins: [common, comReminder, comLic],
  data () {
    return {
      componentName: 'MsgRoot',
      category: 'messages',
      msg: 'メッセージリスト',
      readyToShow: false,
      next: { link: 'MsgCreate', anim: 'slide' },
      messages: [],
      dialogReminderConfig: false,
      loading: false
    }
  },

  created () {
    this.getMessages()
  },

  mounted () {
  },

  // watch: {
  // },

  methods: {
    getMessages () {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.user.userId)
      const messagesRef = userRef.collection('messages')

      this.readyToShow = false

      console.log('getMessages')
      // lastUpdate以降のtimeStampの投稿をごそっと全部取ってくる。
      messagesRef.get()
        .then(snapshot => {
          let recv = []
          if (snapshot.size > 0) {
            for (let i = 0; i < snapshot.size; i++) {
              recv[i] = snapshot.docs[i].data()
            }
            // self.saveItemsToCache()
            self.messages = self.sortDecendingByTimeStamp(recv)
          }
        })
        .then(function () {
          self.readyToShow = true
          self.loading = false
        })
        .catch(err => {
          console.log('Error Get ', this.category, err)
          self.$ons.notification.alert('エラー！通信が安定しているところで再度試してください。')
          self.loading = false
        })
    },

    checkToProceed: async function () {
      const self = this
      let promise = []
      promise.push(this.checkLicense('messages'))
      await Promise.all(promise).then((chk) => {
        if (chk[0]) {
          self.goToMode('MsgCreate', 'create', 'messages')
        }
      })
    },

    showItem: async function (item) {
      const self = this
      let promise = []
      promise.push(this.checkLicenseDue())
      await Promise.all(promise).then((chk) => {
        self.$store.commit('routerAnim/set', 'slide')
        self.$router.push({name: 'MsgCreate', params: {item: item, mode: 'edit', serviceType: 'messages', due: chk[0]}})
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/MsgRoot.vue